// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import {
  PlpWrapper,
  PlpSection,
  PlpSectionTitle,
  FaqList,
  FaqItem,
  FaqQuestion,
  FaqAnswer,
} from './styles';

// constants
import { FAQ_TITLE } from './constants';

// types
import { IListingFaqProps } from './types';

function ListingFaq({ items }: IListingFaqProps) {
  if (isEmpty(items)) {
    return null;
  }
  return (
    <PlpWrapper data-test="listing-faq" data-at="listing-faq">
      <PlpSection className="AEO-plp-section">
        <PlpSectionTitle className="AEO-plp-section-title">{FAQ_TITLE}</PlpSectionTitle>
        <FaqList className="AEO-faq-list">
          {items.map((item, index) => (
            <FaqItem className="AEO-faq-item" key={`listing-faq-${index}`}>
              <FaqQuestion className="AEO-faq-question">
                Q{index + 1}: {item.que}
              </FaqQuestion>
              <FaqAnswer className="AEO-faq-answer">{item.ans}</FaqAnswer>
            </FaqItem>
          ))}
        </FaqList>
      </PlpSection>
    </PlpWrapper>
  );
}

export default memo(ListingFaq);
